enum NotifyErrorMessage {
  UnexpectedError = "Unexpected error",
}

export default NotifyErrorMessage;
